import Vue from 'vue';
import Vuex from 'vuex';

import login from './login';
import notifications from './notifictions';
import campaign from "./campaign";
import app from "./app";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        currentNotification: null, // the notification currently edited or created
    },
    getters: {
        isNotificationEditorOpen(state) {
            return state.currentNotification !== null;
        },
    },
    mutations: {
        setCurrentNotification(state, notification) {
            state.currentNotification = notification;
        }
    },
    actions: {
        createNotificationDialog({commit}, language) {
            commit('setCurrentNotification', this.getters['notifications/createNotification'](language))
        },
        editNotificationDialog({commit}, notification) {
            commit('setCurrentNotification', notification);
        },
        saveNotificationDialog({state, commit, dispatch}) {
            return dispatch('notifications/save', state.currentNotification)
                .then(notification => {
                    commit('setCurrentNotification', null);
                });

        },
        deleteNotificationDialog({state, commit, dispatch}) {
            return dispatch('notifications/delete', state.currentNotification)
                .then(notification => {
                    commit('setCurrentNotification', null);
                });
        },
        closeNotificationDialog({commit}) {
            commit('setCurrentNotification', null);
        }

    },
    modules: {
        login,
        notifications,
        campaign,
        app
    }
})
